import { useState, useCallback } from 'react';

interface ContextMenuState {
  anchorEl: HTMLElement | null;
  data: any;
  mouseX: number;
  mouseY: number;
}

interface UseContextMenuReturn {
  anchorEl: HTMLElement | null;
  contextData: any;
  mouseX: number;
  mouseY: number;
  handleContextMenu: (event: React.MouseEvent, data?: any) => void;
  handleClose: () => void;
  isOpen: boolean;
}

export const useContextMenu = (): UseContextMenuReturn => {
  const [state, setState] = useState<ContextMenuState>({
    anchorEl: null,
    data: null,
    mouseX: 0,
    mouseY: 0
  });

  const handleContextMenu = useCallback((event: React.MouseEvent, data?: any) => {
    event.preventDefault();
    event.stopPropagation();
    
    setState({
      anchorEl: event.currentTarget as HTMLElement,
      data,
      mouseX: event.clientX,
      mouseY: event.clientY
    });
  }, []);

  const handleClose = useCallback(() => {
    setState({
      anchorEl: null,
      data: null,
      mouseX: 0,
      mouseY: 0
    });
  }, []);

  return {
    anchorEl: state.anchorEl,
    contextData: state.data,
    mouseX: state.mouseX,
    mouseY: state.mouseY,
    handleContextMenu,
    handleClose,
    isOpen: Boolean(state.anchorEl)
  };
}; 